
import React, { useEffect } from 'react';
import { PageContainer } from '@/components/layout/PageContainer';
import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import AuthForm from '@/components/auth/AuthForm';

const Index = () => {
  const { user, isLoading, isOnboardingRequired } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(isOnboardingRequired ? "/onboarding" : "/dashboard");
    }
  }, [user, isOnboardingRequired, navigate]);

  if (isLoading) {
    return (
      <PageContainer title="Loading..." subtitle="Please wait">
        <div className="flex justify-center items-center h-[50vh]">
          <div data-testid="loading-spinner" className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      </PageContainer>
    )
  }

  return (
    <PageContainer title="Welcome" subtitle="Sign in to continue">
      <div className="flex flex-col min-h-[75vh] p-4 pb-20 sm:min-h-[50vh] sm:p-8">
        <div className="flex-1 flex items-center justify-center" style={{ paddingTop: '15vh' }}>
          <AuthForm />
        </div>
      </div>
    </PageContainer>
  );
};

export default Index;
